import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getLandlordDeals } from './deals-dashboard.api';
import type { GetLandlordDealsPaginationResponseData } from './application.types';
import { dealsTableKeys, type DealsCountQuery } from './deals-table.query-keys';

export const useFetchPaginatedCount = (query: DealsCountQuery) => {
  const { data, isLoading, isFetching, isPlaceholderData, error } = useQuery({
    // The total ignores page, cursor and sort, so paging never refetches this (expensive) count.
    queryKey: dealsTableKeys.count(query),
    queryFn: (): Promise<GetLandlordDealsPaginationResponseData> =>
      getLandlordDeals({
        applicationTab: query.tab,
        // No page size: the total doesn't depend on it, so rows-per-page changes reuse it.
        limit: 0,
        pageCursor: null,
        search: query.search,
        selectedStatus: query.selectedStatus,
        selectedBuildings: query.selectedBuildings,
        isFromPagination: true,
        leaseDates: query.leaseFilters,
        renewalOpportunityStatus: query.renewalOpportunityStatus,
        includeExpiredDeals: query.includeExpiredDeals,
      }),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    error,
    isFetching,
    isPlaceholderData,
  };
};
